import classNames from "classnames";
import * as React from "react";

import style from "components/typography/textBlock/textBlock.scss";
import utils from "styles/utils.scss";

interface Props {
    children: React.ReactNode;
    testId?: string;
    disableBottomSpacing?: boolean;
    alignCenter?: boolean;
}

export const TextBlock = (props: Props) => {
    const textBlockStyles = () => {
        return classNames(style.textBlock, {
            [utils.noSpacingBottom]: props.disableBottomSpacing,
            [utils.textAlignCenter]: props.alignCenter,
        });
    };
    const renderContent = () => {
        if (typeof props.children === "string") {
            return props.children.split("\n").map((text, index, array) => (
                <React.Fragment key={index}>
                    {text}
                    {index < array.length - 1 && <br />}
                </React.Fragment>
            ));
        }
        return props.children;
    };

    return (
        <p className={textBlockStyles()} data-testid={props.testId}>
            {renderContent()}
        </p>
    );
};
